<template lang="pug">
    header
        //- Tool bar for the storyblok editor
        div(
            v-if="$storyblok.isEditing && isHeaderStory"
            class="border-b mt-4 mb-4 space-x-2 uppercase font-bold relative z-[61]"
        )
            div(
                @click="isSimple = false"
                class="inline-block py-2 px-4 border border-b-0 rounded-t cursor-pointer"
                :class="{'text-white bg-info': !isSimple, 'bg-white': isSimple }"
            ) Standard

            div(
                @click="isSimple = true"
                class="inline-block py-2 px-4 border border-b-0 rounded-t cursor-pointer"
                :class="{'text-white bg-info': isSimple, 'bg-white': !isSimple }"
            ) Simple

        PromoBar(v-if="!isSimpleMode")

        Storyblok(
            :story="header"
            :sectionKey="isSimpleMode ? 'headerSimple' : 'headerStandard'"
        )

        Navbar(v-if="!isSimpleMode")

</template>

<script>
import Navbar from '@/integrations/storyblok/navbar'
import PromoBar from '@/components/promoBar'
import Storyblok from '@/integrations/storyblok'

export default {
    components: {
        Storyblok,
        Navbar,
        PromoBar,
    },
    data() {
        return {
            isSimple: false,
        }
    },
    computed: {
        isSimpleMode() {
            if (this.$storyblok.isEditing) return this.isSimple
            return this.$store.state.isSimpleMode
        },
        header() {
            return this.$sitewideData.header
        },
        isHeaderStory() {
            // Check if the storyblok preview content type is set to 'header' so we only show
            // the toolbar tabs when editing header stories
            return this.$storyblok.contentType === 'header'
        },
    },
}
</script>
